import React from "react";
import "./skills.scss";
import { FaAccessibleIcon, FaCode, FaLaptop, FaRProject, FaSatellite, FaSearchengin } from "react-icons/fa";

const Skills = () => {
  return (
    <div className="skills" id="skills">
      <div className="top">
        <h6>What I do</h6>
        <h1>My expertise areas</h1>
        <p>
          I offer high quality products for competitive prices. My main goal is
          customer satisfaction, which we obtain through market orientation of
          ongoing service and support.
        </p>
      </div>
      <div className="serves">
        <div className="skill">
          <FaCode className='icon'/>
          <h1>Web development</h1>
          <p>
          I am well acquainted in React, Html, Javascript, CSS, Jquery, Bootstrap, and AWS to create the required Performa for your dream website.
          </p>
        </div>
        <div className="skill">
          <FaLaptop className='icon'/>
          <h1>Web design(ui/ux)</h1>
          <p>
          knowledge and skills, sharpened senses and intuition. I use all these mechanisms and other ones to realise your ideas in an online format in a coexisting way with other projects.
          </p>
        </div>
        <div className="skill">
          <FaSearchengin className='icon'/>
          <h1>S.E.O</h1>
          <p>
          Appear at the top of organic searches and unlock the pathway to countless customers looking online for a business just like yours with the Best SEO Services.
          </p>
        </div>
        <div className="skill">
          <FaAccessibleIcon className='icon'/>
          <h1>Graphics design</h1>
          <p>
          knowledge and skills, sharpened senses and intuition. I use all these mechanisms and other ones to realise your ideas in an online format in a coexisting way with other projects.
          </p>
        </div>
        <div className="skill">
          <FaRProject className='icon'/>
          <h1>Brand Management</h1>
          <p>
          I help businesses create a powerful brand image through continuously measuring, monitoring and managing their online activities 
          </p>
        </div>
        <div className="skill">
          <FaSatellite className='icon'/>
          <h1>Social media management</h1>
          <p>
          I create, publish, and analyse content you post on social media platforms like Facebook, Instagram, and Twitter, as well as engaging with users on those platforms.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
